import Vue from 'vue'
import i18n from './assets/js/i18n/i18n.js' // 多语言
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
Vue.prototype.$axios = axios
import "bootstrap"
// 样式
import "bootstrap/dist/css/bootstrap.css"
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
